<ng-container *ngIf="cs.map$ | async as map">
  <ng-container *ngIf="map[selectedId!] as cat">
    <a [routerLink]="['/', cat.productKey, 'cat', cat.id]" [replaceUrl]="true" [matTooltip]="cat.name || ''" matTooltipPosition="above" class="cat-link">
      {{ cat.name }}
    </a>
  </ng-container>
</ng-container>
